import './MainLayout.scss'
import { Header, Nav } from 'components'
import { useTranslation } from 'react-i18next'
// import versionObj from '../version.json'
import { getNavWidth, getStroage } from 'utils'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useState, useRef, useEffect } from 'react'
import { Modal, Popover, message } from 'antd'
import ProForm, { ProFormText } from '@ant-design/pro-form'
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons'
import { useProfileRequest } from 'pages/common/Profile/Hooks'
import { persistor } from 'redux/store'
import { useContextConsumer } from 'context/loginAuthProvider'
import classNames from 'classnames'

const PasswordStrengthIndicator = ({ password }) => {
    const hasUpperCase = /[A-Z]/.test(password)
    const hasLowerCase = /[a-z]/.test(password)
    const hasNumber = /\d/.test(password)
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
    const { t } = useTranslation()

    // 根据强度返回不同的图标和文本
    const getIndicator = type => {
        let result // 用于存储返回值的变量
        switch (type) {
            case 'length':
                if (password.length >= 12) {
                    result = <CheckCircleTwoTone twoToneColor='#52c41a' />
                } else {
                    result = <CloseCircleTwoTone twoToneColor='red' />
                }
                break
            case 'number':
                if (hasNumber) {
                    result = <CheckCircleTwoTone twoToneColor='#52c41a' />
                } else {
                    result = <CloseCircleTwoTone twoToneColor='red' />
                }
                break
            case 'lowercase':
                if (hasLowerCase) {
                    result = <CheckCircleTwoTone twoToneColor='#52c41a' />
                } else {
                    result = <CloseCircleTwoTone twoToneColor='red' />
                }
                break
            case 'uppercase':
                if (hasUpperCase) {
                    result = <CheckCircleTwoTone twoToneColor='#52c41a' />
                } else {
                    result = <CloseCircleTwoTone twoToneColor='red' />
                }
                break
            case 'symbol':
                if (hasSpecialChar) {
                    result = <CheckCircleTwoTone twoToneColor='#52c41a' />
                } else {
                    result = <CloseCircleTwoTone twoToneColor='red' />
                }
                break
            default:
                result = ''
        }
        if (result) {
            return result
        }
    }

    return (
        <div>
            <div>
                {getIndicator('length')}
                <span style={{ marginLeft: 8 }}>{t('Profile.passwordLength')}</span>
            </div>
            <div style={{ padding: '5px 0' }}>
                {getIndicator('number')}
                <span style={{ marginLeft: 8 }}>{t('Profile.passwordNumber')}</span>
            </div>
            <div>
                {getIndicator('lowercase')}
                <span style={{ marginLeft: 8 }}>{t('Profile.passwordLowercase')}</span>
            </div>
            <div style={{ padding: '5px 0' }}>
                {getIndicator('uppercase')}
                <span style={{ marginLeft: 8 }}>{t('Profile.passwordUppercase')}</span>
            </div>
            <div>
                {getIndicator('symbol')}
                <span style={{ marginLeft: 8 }}>{t('Profile.passwordSymbol')}</span>
            </div>
        </div>
    )
}

export const MainLayout = ({ children }) => {
    const flag = useSelector(state => state.HeaderSlice.flag)
    const onceFlag = useSelector(state => state.HeaderSlice.onceFlag)
    const { t } = useTranslation()
    const language = getStroage('language')
    const routeName = useLocation()?.pathname
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectName = userInfo?.user?.projectName
    const outlineBorder = useSelector(state => state.HeaderSlice.outlineBorder)
    const hoverBorder = useSelector(state => state.HeaderSlice.hoverBorder)
    const [version, setVersion] = useState()
    const [isModalVisible, setIsModalVisible] = useState(true)
    const [islogutVisible, setIslogutVisible] = useState(false)
    const [isLoading, setIsloading] = useState(false)
    let passwords = getStroage('password')
    const updatePasswordFormRef = useRef()
    const [popoverVisible, setPopoverVisible] = useState(false)
    const [password, setPassword] = useState('')
    const { putUpdatePassword } = useProfileRequest()
    const { logout } = useContextConsumer()
    const navigate = useNavigate()

    useEffect(() => {
        // 生成当前时间戳（毫秒级）
        const timestamp = new Date().getTime()
        fetch(`version.properties?date=${timestamp}`) // version.properties在public目录下
            .then(response => response.text())
            .then(text => {
                // version信息是key=value格式，例如version=1.0.0
                const versionMatch = text.match(/version=([^\n]+)/)
                if (versionMatch) {
                    setVersion(versionMatch[1])
                }
            })
            .catch(error => console.error('Error fetching version:', error))
    }, [])

    const Footer = (
        <div className='footer'>
            {/* <span>{t('footer.copyright')}</span> */}
            {/* 占位 */}
            <span></span>
            <span>Version: {version}</span>
            {/* <span>
                KL-MegaShare Version: {versionObj?.version} build {versionObj?.hash} on {versionObj?.date}
            </span> */}
        </div>
    )
    getNavWidth(language)

    // 不重复密码验证
    const validatorFun = (rule, value) => {
        const values = updatePasswordFormRef.current.getFieldsValue()
        let result = values.newPassword === value
        if (result) {
            return Promise.resolve()
        } else {
            return Promise.reject(t('Profile.tips4'))
        }
    }

    // 重复密码验证
    const fevalidatorFun = (rule, value) => {
        const values = updatePasswordFormRef.current.getFieldsValue()
        let result = values.oldPassword !== values.newPassword
        if (result) {
            return Promise.resolve()
        } else {
            return Promise.reject(t('Profile.tips6'))
        }
    }

    // 修改
    const handleSave = () => {
        const values = updatePasswordFormRef.current.getFieldsValue()
        const hasUpperCase = /[A-Z]/.test(values.newPassword)
        const hasLowerCase = /[a-z]/.test(values.newPassword)
        const hasNumber = /\d/.test(values.newPassword)
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(values.newPassword)
        if (values.newPassword.length >= 12 && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar) {
            setIsloading(true)
            updatePasswordFormRef.current
                .validateFields()
                .then(() => {
                    const params = { ...values }
                    delete params.confirmPassword
                    putUpdatePassword(params)
                        .then(res => {
                            setIsloading(false)
                            setIsModalVisible(false)
                            setIslogutVisible(true)
                            message.success(t('Profile.tips7'))
                            updatePasswordFormRef.current.resetFields()
                        })
                        .catch(err => setIsloading(false))
                })
                .catch(err => setIsloading(false))
        } else {
            message.error(t('login.passwordWeek'))
        }
    }

    const handlePasswordChange = e => {
        const value = e.target.value
        setPassword(value)
        // 你可以根据需要在这里控制popover的显示逻辑
        // 例如，当密码框有焦点且密码长度大于0时显示
        setPopoverVisible(e.target.value.length > 0)
    }

    const handleBlur = () => {
        // 当密码框失去焦点时，可以隐藏popover
        setPopoverVisible(false)
    }

    const handleClick = async () => {
        window.location.reload(false)
        // dispatch(NavSlice.actions.addSelectedKeys(['/dataSource'])) // 重置路由首页
        await persistor.purge() // 清除 redux 持久存储内容
        // dispatch(LocationSlice.actions.clearLocation()) // 重置 location 狀態
        logout() // 退出登录，清除 token
    }

    return (
        <>
            <div className={'main'}>
                <div
                    className={classNames('main-top', {
                        hidden: routeName === '/AIChat',
                    })}
                >
                    <div
                        className='left'
                        style={{
                            width: getNavWidth(language) + 6 + 'px',
                        }}
                    >
                        <Header.Left isHome={routeName === '/home' ? true : false} />
                    </div>
                    <div
                        className='right'
                        style={{
                            width: `calc(100% - ${getNavWidth(language) + 2 + 'px'})`,
                        }}
                    >
                        <Header.Right isHome={routeName === '/home' ? true : false} />
                    </div>
                </div>
                {routeName === '/home' || routeName === '/AIChat' || (routeName === '/profile' && !projectName) ? (
                    <div className='main-noNav'>
                        {children}
                        <div
                            className={classNames('', {
                                hidden: routeName === '/AIChat',
                            })}
                        >
                            {Footer}
                        </div>
                        <div
                            className={classNames('ai-float-assistant', {
                                hidden: routeName === '/AIChat',
                            })}
                            title='AI 文档助手'
                            onClick={() => {
                                navigate('/AIChat')
                            }}
                        >
                            <div className='ai-wrapper'>
                                {/* 智<br />能
                                <br />助<br />手 */}
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='main-content'>
                        {/* <div className='nav up-nav' > */}
                        {/* 浏览器端菜单滚动的样式 */}
                        <div className={flag === false ? (onceFlag === false ? 'nav' : 'nav up-nav') : 'nav dorw-nav'}>
                            <Nav outlineBorder={outlineBorder} hoverBorder={hoverBorder} />
                        </div>
                        <div
                            className='main-content-router'
                            style={{
                                marginLeft: outlineBorder ? '76px' : getNavWidth(language) + 22 + 'px',
                            }}
                        >
                            <div className='content'>{children}</div>
                            {Footer}
                            {/* <div
                                className={classNames('ai-float-assistant', {
                                    hidden: routeName === '/AIChat',
                                })}
                                title='AI 文档助手'
                                onClick={() => {
                                    navigate('/AIChat')
                                }}
                            >
                                <div className='ai-wrapper'>
                                   
                                </div>
                            </div> */}
                        </div>
                    </div>
                )}
            </div>
            {passwords === 'false' && (
                <Modal
                    closable={false}
                    maskClosable={false}
                    title={t('login.passwordWeek')}
                    visible={isModalVisible}
                    destroyOnClose={true}
                    forceRender={true}
                    // width={600}
                    onOk={handleSave}
                    onCancel={handleClick}
                    confirmLoading={isLoading}
                    // cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <ProForm
                        submitter={false}
                        formRef={updatePasswordFormRef}
                        className='content-form'
                        autoFocusFirstInput={false}
                    >
                        <ProFormText.Password
                            name='oldPassword'
                            label={t('Profile.oldPassword')}
                            fieldProps={{ allowClear: false, placeholder: '' }}
                        />
                        <Popover
                            visible={popoverVisible}
                            trigger='focus'
                            placement='bottom'
                            content={<PasswordStrengthIndicator password={password} />}
                        >
                            <ProFormText.Password
                                name='newPassword'
                                label={t('Profile.newPassword')}
                                onChange={handlePasswordChange}
                                onBlur={handleBlur}
                                fieldProps={{ allowClear: false, placeholder: '' }}
                                rules={[
                                    {
                                        validateTrigger: 'onSubmit',
                                        validator: fevalidatorFun,
                                    },
                                ]}
                            />
                        </Popover>
                        <ProFormText.Password
                            name='confirmPassword'
                            label={t('Profile.confirmPassword')}
                            fieldProps={{ allowClear: false, placeholder: '' }}
                            rules={[
                                {
                                    validateTrigger: 'onSubmit',
                                    validator: validatorFun,
                                },
                            ]}
                            validateTrigger='onSubmit'
                        />
                    </ProForm>
                </Modal>
            )}
            {passwords === 'false' && (
                <Modal
                    // title={t('Profile.tips7')}
                    closable={false}
                    maskClosable={false}
                    visible={islogutVisible}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    onOk={handleClick}
                    okText={t('login.reLogin')}
                >
                    {t('Profile.tips7')}
                </Modal>
            )}
        </>
    )
}
